module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    staticClass: "chapter",
    attrs: {
      "epub:type": "frontmatter",
      "id": "ser"
    }
  }, [_c('p', {
    staticClass: "sert"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "pi"
    }
  }), _vm._v("T"), _c('span', {
    staticClass: "sm"
  }, [_vm._v("HE")]), _vm._v(" T"), _c('span', {
    staticClass: "sm"
  }, [_vm._v("WO")]), _vm._v(" H"), _c('span', {
    staticClass: "sm"
  }, [_vm._v("ORIZONS")]), _vm._v(" O"), _c('span', {
    staticClass: "sm"
  }, [_vm._v("LD")]), _vm._v(" T"), _c('span', {
    staticClass: "sm"
  }, [_vm._v("ESTAMENT")]), _vm._v(" C"), _c('span', {
    staticClass: "sm"
  }, [_vm._v("OMMENTARY")])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', {
    staticClass: "serau"
  }, [_vm._v("J"), _c('span', {
    staticClass: "sm"
  }, [_vm._v(".")]), _vm._v(" G"), _c('span', {
    staticClass: "sm"
  }, [_vm._v("ORDON")]), _vm._v(" M"), _c('span', {
    staticClass: "sm"
  }, [_vm._v("C")]), _vm._v("C"), _c('span', {
    staticClass: "sm"
  }, [_vm._v("ONVILLE")]), _vm._v(" and C"), _c('span', {
    staticClass: "sm"
  }, [_vm._v("RAIG")]), _vm._v(" B"), _c('span', {
    staticClass: "sm"
  }, [_vm._v("ARTHOLOMEW")]), _vm._v(", "), _c('i', [_vm._v("General Editors")])]), _vm._v(" "), _c('p', {
    staticClass: "serf"
  }, [_vm._v("Two features distinguish T"), _c('span', {
    staticClass: "sm"
  }, [_vm._v("HE")]), _vm._v(" T"), _c('span', {
    staticClass: "sm"
  }, [_vm._v("WO")]), _vm._v(" H"), _c('span', {
    staticClass: "sm"
  }, [_vm._v("ORIZONS")]), _vm._v(" O"), _c('span', {
    staticClass: "sm"
  }, [_vm._v("LD")]), _vm._v(" T"), _c('span', {
    staticClass: "sm"
  }, [_vm._v("ESTAMENT")]), _vm._v(" C"), _c('span', {
    staticClass: "sm"
  }, [_vm._v("OMMENTARY")]), _vm._v(" series: theological exegesis and theological reflection.")]), _vm._v(" "), _c('p', {
    staticClass: "ser"
  }, [_vm._v("Exegesis since the Reformation era and especially in the past two hundred years emphasized careful attention to philology, grammar, syntax, and concerns of a historical nature. More recently, commentary has expanded to include social-scientific, political, or canonical questions and more.")]), _vm._v(" "), _c('p', {
    staticClass: "ser"
  }, [_vm._v("Without slighting the significance of those sorts of questions, scholars in T"), _c('span', {
    staticClass: "sm"
  }, [_vm._v("HE")]), _vm._v(" T"), _c('span', {
    staticClass: "sm"
  }, [_vm._v("WO")]), _vm._v(" H"), _c('span', {
    staticClass: "sm"
  }, [_vm._v("ORIZONS")]), _vm._v(" O"), _c('span', {
    staticClass: "sm"
  }, [_vm._v("LD")]), _vm._v(" T"), _c('span', {
    staticClass: "sm"
  }, [_vm._v("ESTAMENT")]), _vm._v(" C"), _c('span', {
    staticClass: "sm"
  }, [_vm._v("OMMENTARY")]), _vm._v(" locate their primary interests on theological readings of texts, past and present. The result is a paragraph-by-paragraph engagement with the text that is deliberately theological in focus.")]), _vm._v(" "), _c('p', {
    staticClass: "ser"
  }, [_vm._v("Theological reflection in T"), _c('span', {
    staticClass: "sm"
  }, [_vm._v("HE")]), _vm._v(" T"), _c('span', {
    staticClass: "sm"
  }, [_vm._v("WO")]), _vm._v(" H"), _c('span', {
    staticClass: "sm"
  }, [_vm._v("ORIZONS")]), _vm._v(" O"), _c('span', {
    staticClass: "sm"
  }, [_vm._v("LD")]), _vm._v(" T"), _c('span', {
    staticClass: "sm"
  }, [_vm._v("ESTAMENT")]), _vm._v(" C"), _c('span', {
    staticClass: "sm"
  }, [_vm._v("OMMENTARY")]), _vm._v(" takes many forms, including locating each Old Testament book in relation to the whole of Scripture — asking what the biblical book contributes to biblical theology — and in conversation with constructive theology of today. How commentators engage in the work of theological reflection will differ from book to book, depending on their particular theological tradition and how they perceive the work of biblical theology and theological hermeneutics. This heterogeneity derives as well from the relative infancy of the project of theological interpretation of Scripture in modern times and from the challenge of grappling with a book’s message in Greco-Roman antiquity, in the canon of Scripture and history of interpretation, and for life in the admittedly diverse Western world at the beginning of the twenty-first century.")]), _vm._v(" "), _c('p', {
    staticClass: "ser"
  }, [_vm._v("T"), _c('span', {
    staticClass: "sm"
  }, [_vm._v("HE")]), _vm._v(" T"), _c('span', {
    staticClass: "sm"
  }, [_vm._v("WO")]), _vm._v(" H"), _c('span', {
    staticClass: "sm"
  }, [_vm._v("ORIZONS")]), _vm._v(" O"), _c('span', {
    staticClass: "sm"
  }, [_vm._v("LD")]), _vm._v(" T"), _c('span', {
    staticClass: "sm"
  }, [_vm._v("ESTAMENT")]), _vm._v(" C"), _c('span', {
    staticClass: "sm"
  }, [_vm._v("OMMENTARY")]), _vm._v(" is written primarily for students, pastors, and other Christian leaders seeking to engage in theological interpretation of Scripture.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2ed2f61a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/eer-lucas-0002.vue
// module id = 57
// module chunks = 0